import { RefDate, RefNumber, RefString } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { PackageFromCustomerStepRawData } from "./PackageFromCustomerStepRawData";
import { PackageFromCustomerStepState } from "./PackageFromCustomerStepState";


export class PackageFromCustomerStepData extends StepData
{
    public PlannedDispatchTime = new RefDate(new Date(0));
    public PackageSendDeclared = new RefDate(new Date(0));
    public Carrier = new RefString("Inpost");
    public ManaInPackage = new RefNumber();
    public DeliveryTime = new RefDate(new Date(0));
    public PackageContentNotOkInfo = new RefString();
    public PackageCost = new RefNumber();

    constructor(raw: Partial<PackageFromCustomerStepRawData>)
    {
        super(raw);

        this.State.value ||= PackageFromCustomerStepState.ReturnInfo;

        this.PackageSendDeclared.value = new Date(raw?.PackageSendDeclared || 0);
        this.PlannedDispatchTime.value = new Date(raw?.PlannedDispatchTime || 0);
        this.Carrier.value = raw?.Carrier || "Inpost";
        this.ManaInPackage.value = raw?.ManaInPackage || 0;
        this.DeliveryTime.value = new Date(raw?.DeliveryTime || 0);
        this.PackageContentNotOkInfo.value = raw?.PackageContentNotOkInfo || "";
        this.PackageCost.value = raw?.PackageCost || 0;
    }
}
